import { KVKKPageSEO } from '@/components/SEOHead';
import { Card, CardContent } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Shield } from 'lucide-react';

const KVKKPage = () => {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="kvkk-page">
      <KVKKPageSEO />
      
      {/* Hero */}
      <section className="bg-emerald-800 py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <Shield className="w-16 h-16 text-lime-300 mx-auto mb-4" />
          <h1 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            Kişisel Verilerin Korunması Politikası
          </h1>
          <p className="text-lg text-emerald-100 max-w-2xl mx-auto">
            AVRASYA SPORTİF FAALİYETLER - KVKK Aydınlatma Metni
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Card>
            <CardContent className="p-6 md:p-8">
              <div className="prose prose-slate max-w-none">
                <p className="text-slate-600 leading-relaxed mb-6">
                  Kişisel verilerin korunması, AVRASYA SPORTİF FAALİYETLER Şahıs Şirketi'nin ("Şirket") en önemli öncelikleri arasında yer almaktadır. Bu konunun en önemli kısmını ise işbu Politika ile yönetilen; ziyaretçilerimizin, potansiyel ürün veya hizmet alıcılarımızın, hizmetin sunulduğu kişilerin ve üçüncü kişilerin kişisel verilerinin korunması ve işlenmesi oluşturmaktadır.
                </p>

                <p className="text-slate-600 leading-relaxed mb-6">
                  T.C. Anayasası'na göre, herkes, kendisiyle ilgili kişisel verilerin korunmasını isteme hakkına sahiptir. Anayasa ile güvence altına alınan bir hak olan kişisel verilerin korunması konusunda şirket, işbu Politika ile yönetilen; ziyaretçilerimizin, potansiyel ürün veya hizmet alıcılarımızın, hizmetin sunulduğu kişilerin ve üçüncü kişilerin kişisel verilerinin korunmasına gerekli özeni göstermekte ve bunu bir Şirket politikası haline getirmektedir.
                </p>

                <h3 className="text-xl font-bold text-slate-900 mt-8 mb-4">Temel İlkeler</h3>
                <ul className="list-disc pl-6 space-y-2 text-slate-600">
                  <li>Kişisel verileri hukuka ve dürüstlük kurallarına uygun işleme</li>
                  <li>Kişisel verileri doğru ve gerektiğinde güncel tutma</li>
                  <li>Kişisel verileri belirli, açık ve meşru amaçlar için işleme</li>
                  <li>Kişisel verileri işlendikleri amaçla bağlantılı, sınırlı ve ölçülü işleme</li>
                  <li>Kişisel verileri ilgili mevzuatta öngörülen veya işlendikleri amaç için gerekli olan süre kadar muhafaza etme</li>
                  <li>Kişisel veri sahiplerini aydınlatma ve bilgilendirme</li>
                  <li>Kişisel veri sahiplerinin haklarını kullanması için gerekli sistemi kurma</li>
                  <li>Kişisel verilerin muhafazasında gerekli tedbirleri alma</li>
                  <li>Özel nitelikli kişisel verilerin işlenmesine ve korunmasına gerekli hassasiyeti göstermek</li>
                </ul>

                <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">MADDE 1: POLİTİKA'NIN AMACI</h2>
                <p className="text-slate-600 leading-relaxed">
                  Politikanın temel amacı, şirket tarafından hukuka uygun bir biçimde yürütülen kişisel veri işleme faaliyeti ve bu kapsamda müşterilerimiz, ziyaretçilerimiz, potansiyel ürün veya hizmet alıcılarımız, hizmetin sunulduğu kişiler ve üçüncü kişiler başta olmak üzere kişisel verileri şirketimiz tarafından işlenen kişileri bilgilendirilerek şeffaflık ve güveni sağlamaktır.
                </p>

                <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">MADDE 2: İÇERİK VE TANIMLAR</h2>
                <p className="text-slate-600 leading-relaxed mb-4">
                  Bu Politika; ziyaretçilerimizin, potansiyel ürün veya hizmet alıcılarımızın, hizmetin sunulduğu kişilerin ve üçüncü kişilerin otomatik olan ya da herhangi bir veri kayıt sisteminin parçası olmak kaydıyla otomatik olmayan yollarla işlenen tüm kişisel verilerine ilişkindir.
                </p>

                <div className="bg-slate-50 rounded-lg p-4 my-6">
                  <h4 className="font-bold text-slate-900 mb-3">Tanımlar:</h4>
                  <ul className="space-y-2 text-sm text-slate-600">
                    <li><strong>Açık rıza:</strong> Belirli bir konuya ilişkin, bilgilendirilmeye dayanan ve özgür iradeyle açıklanan rıza</li>
                    <li><strong>Kişisel veri:</strong> Kimliği belirli veya belirlenebilir gerçek kişiye ilişkin her türlü bilgi</li>
                    <li><strong>Özel nitelikli kişisel veri:</strong> Kişilerin ırkı, etnik kökeni, siyasi düşüncesi, felsefi inancı, dini, mezhebi veya diğer inançları, kılık ve kıyafeti, dernek, vakıf ya da sendika üyeliği, sağlığı, cinsel hayatı, ceza mahkûmiyeti ve güvenlik tedbirleriyle ilgili verileri ile biyometrik ve genetik verileri</li>
                    <li><strong>Veri sorumlusu:</strong> Kişisel verilerin işleme amaçlarını ve vasıtalarını belirleyen, veri kayıt sisteminin kurulmasında ve yönetilmesinden sorumlu gerçek veya tüzel kişi</li>
                    <li><strong>İlgili kişi:</strong> Kişisel verisi işlenen gerçek kişi</li>
                  </ul>
                </div>

                <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">MADDE 5: KİŞİSEL VERİLERİN KORUNMASINA İLİŞKİN HUSUSLAR</h2>
                <p className="text-slate-600 leading-relaxed">
                  Şirketimiz, KVKK'nın 12. Maddesi uyarınca, işlemekte olduğu kişisel verilerin hukuka aykırı olarak işlenmesini önlemek, verilere hukuka aykırı olarak erişilmesini önlemek ve verilerin muhafazasını sağlamak için uygun güvenliği sağlamak için gereken idari, teknik ve hukuki tüm tedbirleri almakta, bu kapsamda gereken tüm denetimleri sağlamaktadır.
                </p>

                <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">MADDE 6: KİŞİSEL VERİLERİN GÜVENLİĞİNİN SAĞLANMASI</h2>
                
                <h3 className="text-lg font-bold text-slate-800 mt-6 mb-3">6.1 Teknik Tedbirler</h3>
                <ul className="list-disc pl-6 space-y-2 text-slate-600">
                  <li>Şirketimiz bünyesinde gerçekleştirilen kişisel veri işleme faaliyetleri teknik sistemlerle denetlenmektedir</li>
                  <li>Teknolojideki gelişmelere uygun teknik önlemler alınmakta, alınan önlemler periyodik olarak güncellenmekte ve yenilenmektedir</li>
                  <li>Virüs koruma sistemleri ve güvenlik duvarlarını içeren yazılımlar ve donanımlar kurulmaktadır</li>
                </ul>

                <h3 className="text-lg font-bold text-slate-800 mt-6 mb-3">6.2 İdari Tedbirler</h3>
                <ul className="list-disc pl-6 space-y-2 text-slate-600">
                  <li>Şirketimizin yürütmüş olduğu kişisel veri işleme faaliyetleri 6698 Sayılı Kanun'un aradığı kişisel veri işleme şartlarına uygunluğun sağlanması için belirlenmektedir</li>
                  <li>Şirketimiz hukuksal uyum gerekliliklerinin sağlanması için uygulama kuralları belirlemekte; bu hususların denetimini ve uygulamanın sürekliliğini sağlamak için gerekli idari tedbirler almaktadır</li>
                </ul>

                <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">MADDE 7: VERİ SAHİBİNİN HAKLARI</h2>
                <p className="text-slate-600 leading-relaxed mb-4">
                  Kişisel veri sahipleri aşağıda sıralanan haklarına ilişkin taleplerini yazılı olarak Şirketimize iletmeleri durumunda Şirketimiz talebin niteliğine göre talebi en kısa sürede ve en geç otuz gün içinde ücretsiz olarak sonuçlandırmaktadır.
                </p>
                <ul className="list-disc pl-6 space-y-2 text-slate-600">
                  <li>Kişisel veri işlenip işlenmediğini öğrenme</li>
                  <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme</li>
                  <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                  <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme</li>
                  <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
                  <li>İşlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerin silinmesini veya yok edilmesini isteme</li>
                  <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme</li>
                  <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme</li>
                </ul>

                <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">MADDE 16: KİŞİSEL VERİLERİN KATEGORİZASYONU</h2>
                <div className="space-y-4 text-slate-600">
                  <p><strong>KİMLİK BİLGİSİ:</strong> Ehliyet, Nüfus Cüzdanı, İkametgâh, Pasaport gibi dokümanlarda yer alan tüm bilgiler.</p>
                  <p><strong>İLETİŞİM BİLGİSİ:</strong> Telefon numarası, adres ve e-mail gibi bilgiler.</p>
                  <p><strong>MÜŞTERİ BİLGİSİ:</strong> Ticari faaliyetlerimiz neticesinde ilgili kişi hakkında elde edilen ve üretilen bilgiler.</p>
                  <p><strong>İŞLEM GÜVENLİĞİ BİLGİSİ:</strong> Teknik, idari, hukuki ve ticari güvenliğimizi sağlamamız için işlenen kişisel verileriniz.</p>
                </div>

                <h2 className="text-2xl font-bold text-slate-900 mt-10 mb-4">BAŞVURU VE İLETİŞİM</h2>
                <div className="bg-emerald-50 rounded-lg p-6 mt-4">
                  <p className="text-slate-700 mb-4">Kişisel veri sahipleri haklarına ilişkin taleplerini aşağıdaki yöntemlerle iletebilirler:</p>
                  <ul className="space-y-2 text-slate-600">
                    <li><strong>E-posta:</strong> avrasyasportifdestek@gmail.com</li>
                    <li><strong>Adres:</strong> Altıntepe Mah. Galipbey Cad. Dış Kapı No: 119/A Dükkân No: 2 Esen Apt., Maltepe/İSTANBUL</li>
                  </ul>
                </div>

                <p className="text-sm text-slate-500 mt-8 pt-4 border-t">
                  Son güncelleme: Aralık 2025
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default KVKKPage;
